import { FC } from 'react'

import { LoadingSpinner } from '../../../../@paco/components'

import { areDatesInSameMonth, formatDate } from '../../../../helpers/date'
import { DayPropsInterface } from './models'
import Day from './subcomponents/Day/Day'

import './Days.scss'

interface DaysProps extends DayPropsInterface {
    isLoading?: boolean;
    selectedDays: Date[];
}

const Days: FC<DaysProps> = ({
    mode,
    mobile = false,
    leaveOfAbsences,
    absences,
    preferToWorkTimeSlots,
    unavailableToWorkTimeSlots,
    onResourceClick,
    isLoading = false,
    selectedDays,
}) => (
    <>
        {selectedDays.map(day => {
            const key = formatDate(day)
            const outOfRange = mode === 'month' && ! areDatesInSameMonth(day, selectedDays[selectedDays.length - 1])

            return (
                <Day
                    key={key}
                    outOfRange={outOfRange}
                    day={day}
                    mode={mode}
                    mobile={mobile}
                    leaveOfAbsences={leaveOfAbsences}
                    absences={absences}
                    preferToWorkTimeSlots={preferToWorkTimeSlots}
                    unavailableToWorkTimeSlots={unavailableToWorkTimeSlots}
                    onResourceClick={onResourceClick}
                />
            )
        })}

        {isLoading && <LoadingSpinner className="availability-days__loading-spinner" />}
    </>
)

export default Days
